
// Localização: frontend/src/hooks/usePonto.js

import { useState, useCallback } from 'react';
import api from '../api/api';

/**
 * Hook personalizado para buscar e gerenciar o status de Check-in/Check-out.
 * (Se o profissional está com um atendimento ativo 'Em Andamento').
 */
export function usePonto() {
    const [pontoStatus, setPontoStatus] = useState({
        is_checked_in: false,
        data: null // Dados do agendamento ativo (agendamento_id, paciente_id, etc)
    });
    const [isPontoLoading, setIsPontoLoading] = useState(true);
    const [pontoError, setPontoError] = useState(null);

    // Função para buscar o status atual do ponto
    const fetchPontoStatus = useCallback(async () => {
        setIsPontoLoading(true);
        setPontoError(null);
        try {
            // Rota GET /api/ponto/status (Implementada no seu pontoController.js)
            const response = await api.get('/ponto/status'); 
            
            setPontoStatus(response.data);

        } catch (err) {
            console.error('Erro ao buscar status do Ponto:', err);
            // Em caso de erro 401/403 (Token expirado, etc.), assumimos que não há check-in
            if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                 setPontoStatus({ is_checked_in: false, data: null });
            } else {
                 setPontoError('Falha ao verificar o status do Check-in.');
            }
        } finally {
            setIsPontoLoading(false);
        }
    }, []);

    // Função para simular o check-in (Chamada de forma separada no componente de Agendamento)
    const handleCheckIn = useCallback(async (agendamento_id, coords) => {
        // ... (Aqui viria a chamada POST para /api/ponto/checkin)
        // Por simplificação, focamos apenas na busca do status aqui
        // Mas esta função seria usada na página de Agendamentos.
    }, []);
    
    // Auto-carrega o status na montagem (se não estiver sendo usado em um contexto específico)
    // Deixaremos o carregamento no `DiarioCuidadosPage.js` para maior controle.

    return {
        pontoStatus,
        isPontoLoading,
        pontoError,
        fetchPontoStatus,
        handleCheckIn,
        // ... (Futuramente, handleCheckOut, etc.)
    };
}